// @flow
const shapeAbbreviations: { [string]: string } = {
  Round: 'B',
  Pear: 'P',
  Emerald: 'E',
  Marquise: 'M',
  Oval: 'O',
  Radiant: 'R',
  Princess: 'PR',
  Cushion: 'C',
  Heart: 'H',
  Asscher: 'AS'
};

const shapeAbbreviationsFromLower: { [string]: string } = {
  round: 'B',
  pear: 'P',
  emerald: 'E',
  marquise: 'M',
  oval: 'O',
  radiant: 'R',
  princess: 'PR',
  cushion: 'C',
  heart: 'H',
  asscher: 'AS'
};

const shapeNames: { [string]: string } = {
  B: 'Round',
  P: 'Pear',
  E: 'Emerald',
  M: 'Marquise',
  O: 'Oval',
  R: 'Radiant',
  PR: 'Princess',
  C: 'Cushion',
  H: 'Heart',
  AS: 'Asscher'
};

const lowerShapeNames: { [string]: string } = {
  B: 'round',
  P: 'pear',
  E: 'emerald',
  M: 'marquise',
  O: 'oval',
  R: 'radiant',
  PR: 'princess',
  C: 'cushion',
  H: 'heart',
  AS: 'asscher'
};

const alphaAbbreviations: { [string]: string } = {
  Excellent: 'EX',
  'Very Good': 'VG',
  Good: 'G',
  Fair: 'F',
  Poor: 'P'
};

// this list reflects the same list as Diamond::GIRDLE_DISPLAY_VALUES_MAP, keep them in sync
const girdleDisplayValues: { [string]: string } = {
  M: 'Medium',
  STK: 'Slightly Thick',
  STN: 'Slightly Thin',
  TK: 'Thick',
  TN: 'Thin',
  VTK: 'Very Thick',
  VTN: 'Very Thin',
  XTK: 'Ext. Thick',
  XTN: 'Ext. Thin',
};

export {
  shapeAbbreviations,
  shapeAbbreviationsFromLower,
  shapeNames,
  lowerShapeNames,
  alphaAbbreviations,
  girdleDisplayValues,
};
